import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { LoadingState } from "@/components/common/States";

export function ProtectedRoute({ children, roles }) {
  const { user } = useStore();
  const location = useLocation();

  if (user === null) return <LoadingState label="Checking session..." />;
  if (user === false) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="max-w-lg mx-auto px-4 py-24 text-center">
        <h1 className="text-2xl font-serif font-bold text-stone-900">Access Restricted</h1>
        <p className="mt-2 text-stone-600">Your account role ({user.role}) does not have access to this module.</p>
      </div>
    );
  }
  return children;
}
